import { Injectable, ComponentFactoryResolver } from '@angular/core';
import * as momenttz from 'moment-timezone';

var moment = require('moment')
var momentDurationFormatSetup = require("moment-duration-format");

@Injectable()
export class MomentService {

  constructor() { momentDurationFormatSetup(moment) }

  format(dateString: string): string {
    let time = moment(dateString);
    return moment(time).utc().format('MM/DD/YYYY');
  }

  formatMilliseconds(ms: number): string{
    return moment.duration(ms, "milliseconds").format("d[D] h[H] m[M]");
  }

  formatWithTimeAndZone(dateString: string, timezone: string): string {
    let time = moment(dateString);
    time = moment(time).utc();
    return momenttz.tz(time, timezone).format('MM/DD/YYYY @ hh:mm A');
  }

  formatWithTime(dateString: string): string {
    let time = moment(dateString);
    return moment(time).utc().format('MM/DD/YYYY @ hh:mm A');
  }

  formatClaimTimeStamp(dateString: string): string {
    return moment(dateString).format('MM/DD/YYYY hh:mm A');
  }

  getDateRangeCateogories() {
    let dateFrom = moment(Date.now()).subtract(14, 'months').endOf('month').format('YYYY-MM-DD');
    let startYear = moment(dateFrom).year();
    let startYearMonth = moment(dateFrom).month() + 1;
    let currentYear = (new Date()).getFullYear();
    let currentMonth = (new Date()).getMonth() + 1;
    let categories = [];
    let yearsObj = {};
    let months = {
      '1': 'JAN',
      '2': 'FEB',
      '3': 'MAR',
      '4': 'APR',
      '5': 'MAY',
      '6': 'JUN',
      '7': 'JUL',
      '8': 'AUG',
      '9': 'SEP',
      '10': 'OCT',
      '11': 'NOV',
      '12': 'DEC'
    };
    for (let i = startYear; i <= currentYear; i++) {
      yearsObj[i] = [];
        if (i === startYear) {
            for(let key in months) {
              if(parseInt(key) >= startYearMonth ){
                categories.push(months[key] + '-' + i.toString());
                yearsObj[i].push(key)
              }
          }
        }
        else if (i === currentYear) {
            for(let key in months) {
              if(parseInt(key) <= currentMonth){
                categories.push(months[key] + '-' + i.toString());
                yearsObj[i].push(key)
              }
          }
        }
        else {
            for(let key in months) {
               categories.push(months[key] + '-' + i.toString());
                yearsObj[i].push(key)
          }

        }

    }
    return {categories: categories, yearsObj: yearsObj};
  }

  getYear(date = null) {
    if (date) {
      return moment(date).year();
    }
    else { return moment().year(); }

  }

  getMonth(date = null) {
    if (date) {
      return moment(date).month() + 1;
    }
    else { return moment().month() + 1; }
  }

  getDay(date = null) {
    if (date) {
      if (moment(date).date() === 0 || moment(date).date() === 1) {
        return null;
      }
      else {
        return moment(date).date();
      }
    }
    else {
      // if we pass in 0 to my calender we will invalidate the restrictions
      if (moment().date() === 0 || moment().date() === 1) {
        return null;
      }
      else {
        return moment().date() - 1;
      }
    }
  }

}
